// extracted by mini-css-extract-plugin
export default {"spinMobile":"edit_spinMobile__KHuTJ"};